import { useCallback, useRef } from 'react'

const useExitModePrevention = () => {
  // Refs
  const shouldPreventExitEditingMode = useRef<boolean>(false)
  const shouldTogglePreventExitEditingMode = useRef<boolean>(false)

  const resetPreventExitEditingMode = useCallback(() => {
    shouldPreventExitEditingMode.current = false
    shouldTogglePreventExitEditingMode.current = false
  }, [])

  /**
   * Checks if exiting editing mode should be prevented.
   */
  const checkPreventExitEditingMode = useCallback(() => {
    // If not using toggle ref, simply return the main ref value
    if (!shouldTogglePreventExitEditingMode.current && shouldPreventExitEditingMode.current) {
      return true
    }

    // If using toggle ref, reset both refs and return false to allow exiting editing mode
    if (shouldTogglePreventExitEditingMode.current) {
      resetPreventExitEditingMode()
      return true
    }

    return false
  }, [resetPreventExitEditingMode])

  return {
    shouldPreventExitEditingMode,
    shouldTogglePreventExitEditingMode,
    checkPreventExitEditingMode,
    resetPreventExitEditingMode,
  }
}

export default useExitModePrevention
